/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RevertBedSwapEligibilityResponse } from './RevertBedSwapEligibilityResponse';
import {
    RevertBedSwapEligibilityResponseFromJSON,
    RevertBedSwapEligibilityResponseFromJSONTyped,
    RevertBedSwapEligibilityResponseToJSON,
} from './RevertBedSwapEligibilityResponse';

/**
 * 
 * @export
 * @interface CheckRevertBedSwapEligibility200Response
 */
export interface CheckRevertBedSwapEligibility200Response {
    /**
     * 
     * @type {RevertBedSwapEligibilityResponse}
     * @memberof CheckRevertBedSwapEligibility200Response
     */
    data?: RevertBedSwapEligibilityResponse;
}

/**
 * Check if a given object implements the CheckRevertBedSwapEligibility200Response interface.
 */
export function instanceOfCheckRevertBedSwapEligibility200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckRevertBedSwapEligibility200ResponseFromJSON(json: any): CheckRevertBedSwapEligibility200Response {
    return CheckRevertBedSwapEligibility200ResponseFromJSONTyped(json, false);
}

export function CheckRevertBedSwapEligibility200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckRevertBedSwapEligibility200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : RevertBedSwapEligibilityResponseFromJSON(json['data']),
    };
}

export function CheckRevertBedSwapEligibility200ResponseToJSON(value?: CheckRevertBedSwapEligibility200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': RevertBedSwapEligibilityResponseToJSON(value.data),
    };
}

